import { EditorState, Plugin, Transaction } from 'prosemirror-state'
import { mappedStepPositions } from './utils/mappedStepPositions'

import { BlockIdFixMetaKey } from 'proseShared/plugins/BlockId/BlockIdPlugin'

// we use zero width spaces to delimit inline code
// this plugin clears them up whenever inline code is deleted
export const CleanUpZeroWidthSpaces = new Plugin({
  appendTransaction: (trs: Transaction[], _oldState: EditorState, newState: EditorState) => {
    if (trs.some((tr) => tr.getMeta('realTime'))) return

    const newTr = newState.tr
    mappedStepPositions(trs).forEach(({ from, to, tr }) => {
      if (tr.getMeta(BlockIdFixMetaKey)) return null

      const $from = newTr.doc.resolve(newTr.mapping.map(from))

      if ($from.nodeBefore?.textContent.endsWith('\u200B') && $from.nodeAfter?.textContent.startsWith('\u200B')) {
        newTr.delete(from - 1, from + 1)
      }

      if ($from.nodeBefore?.textContent.endsWith('\u200B\u200B')) {
        newTr.delete(from - 2, from)
      }

      if ($from.nodeAfter?.textContent.startsWith('\u200B\u200B')) {
        newTr.delete(from, from + 1)
      }
    })

    if (newTr.docChanged) return newTr
  },
})
